var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { SvgIcon } from '../svg-icon';
export var BorderPillIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentColor' : _b, rootProps = __rest(_a, ["color"]);
    return (React.createElement(SvgIcon, __assign({ viewBox: "0 0 14 14" }, rootProps),
        React.createElement("path", { fillRule: "evenodd", d: "M7 0.25C3.27208 0.25 0.25 3.27208 0.25 7C0.25 10.7279 3.27208 13.75 7 13.75H13C13.4142 13.75 13.75 13.4142 13.75 13V11.5C13.75 11.0858 13.4142 10.75 13 10.75C12.5858 10.75 12.25 11.0858 12.25 11.5V12.25H7C4.10051 12.25 1.75 9.8995 1.75 7C1.75 4.10051 4.10051 1.75 7 1.75H12.25V2.5C12.25 2.91421 12.5858 3.25 13 3.25C13.4142 3.25 13.75 2.91421 13.75 2.5V1C13.75 0.585786 13.4142 0.25 13 0.25H7ZM13.75 5.5C13.75 5.08579 13.4142 4.75 13 4.75C12.5858 4.75 12.25 5.08579 12.25 5.5V8.5C12.25 8.91421 12.5858 9.25 13 9.25C13.4142 9.25 13.75 8.91421 13.75 8.5V5.5Z", fill: color })));
};
